module.exports = __webpack_public_path__ + "img/Cluster.a4da0c20.png";